import {MODES} from '../../IssueProfile/Modes';

export const executeIssueProfileAddAction = parent => {
    parent.props.history.push({
        pathname: '/issueProfile/addIssueProfile',
        state: {mode: MODES.ADD},
    });
};
